<template>
  <ul class="months">
    <li
      v-for="(month, index) in availableMonths"
      :key="month"
    >
      <button
        class="button month"
        :class="{active: isActiveMonth(index)}"
        :disabled="isFutureMonth(index)"
        @click="changeMonth(index)"
      >
        {{ month }}
      </button>
    </li>
  </ul>
</template>

<script>
import { getMonth, isSameYear } from 'date-fns'
import { MONTHS } from '@/misc/months'

export default {
  props: {
    currentYearDate: {
      type: Date,
      default: new Date()
    },
    currentMonthDate: {
      type: Date,
      default: new Date()
    }
  },
  data () {
    return {
      availableMonths: MONTHS['en']
    }
  },
  computed: {
    isThisYear () {
      return isSameYear(this.currentYearDate, new Date())
    }
  },
  methods: {
    isActiveMonth (monthIndex) {
      const sameMonth = getMonth(this.currentMonthDate) === monthIndex
      const sameYear = isSameYear(this.currentMonthDate, this.currentYearDate)
      return sameMonth && sameYear
    },
    isFutureMonth (monthIndex) {
      return this.isThisYear && getMonth(new Date()) <= monthIndex
    },
    changeMonth (monthIndex) {
      this.$emit('month-change', monthIndex)
    }
  }
}
</script>

<style scoped lang="scss">
.months {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  width: 100%;

  .month {
    width: 80px;
    height: 22px;
    margin-bottom: 10px;
    border-radius: $border-radius;
    font-size: 10px;
  }

  .active {
    border: 1px solid rgba(0, 0, 0, 0.2);
    color: $white;
    background: #16c6b9;

    &:hover,
    &:focus,
    &:focus:not(:active) {
      border: 1px solid rgba(0, 0, 0, 0.2);
      color: $white;
    }
  }
}
</style>
